import en from './en'
import es from './es'

export default {
  en: en,
  es: es
}
